import { render, staticRenderFns } from "./KanBanRouterPass.vue?vue&type=template&id=a0342aca"
import script from "./KanBanRouterPass.vue?vue&type=script&lang=js"
export * from "./KanBanRouterPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports